import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Upload } from 'antd';
import { UploadLabel, UploadTitle, File, ClickUpload } from './components';
import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';
import size from 'lodash/size';

const { Dragger } = Upload;

const Draggable = ({
  item,
  disabled,
  uploadedFiles,
  setUploadedFiles,
  openRedeemOverwriteModal
}) => {
  const {
    label,
    subLabel,
    linkText,
    multiple = false,
    fileCode, // used as the 'type'
    fileAccepts = '.pdf,.png,.jpg,.jpeg',
    fileLimit = 10, // MB
    required,
  } = item;

  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const [errorFile, setErrorFile] = useState('');
  const [notAcceptedSize, setNotAcceptedSize] = useState(false);
  const [notAcceptedType, setNotAcceptedType] = useState(false);

  const isInvalidType = (type) =>
    !['pdf', 'png', 'jpeg', 'jpg'].some(ext => type.includes(ext));

  const handleFileUpload = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      let base64 = reader.result;
      // Replace the default MIME type with your custom one
      base64 = base64.split(',')[1]; // Keep only the part after "base64,"

      const newFile = {
        type: fileCode, // fileCode from props.item
        filename: file.name,
        content: base64,
        size: file.size
      };

      setUploadedFiles([newFile]);       
      resolve(false);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
};

  const beforeUpload = (file) => {
    const maxSize = fileLimit * 1024 * 1024;

    if (file.size > maxSize) {
      setErrorFile(`${file.name} is too large (max ${fileLimit}MB).`);
      setNotAcceptedSize(true);
      return false;
    }

    if (isInvalidType(file.type)) {
      setErrorFile(`${file.name} has unsupported file type.`);
      setNotAcceptedType(true);
      return false;
    }

    setErrorFile('');
    setNotAcceptedSize(false);
    setNotAcceptedType(false);
    handleFileUpload(file);
    return false;
  };

  const handleDelete = (fileToDelete) => {
    const updatedFiles = uploadedFiles.filter(f => f.filename !== fileToDelete.filename);
    setUploadedFiles(updatedFiles); // ✅ always an array
  };

  const props = {
    name: 'file',
    multiple,
    accept: fileAccepts,
    beforeUpload,
    showUploadList: false,
  };

  const safeFiles = Array.isArray(uploadedFiles) ? uploadedFiles : [];

  return (
    <div className={`ant-drag-container ${disabled ? 'upload-disabled' : ''}`}>
      <UploadLabel
        label={label}
        subLabel={subLabel}
        linkText={linkText}
        fileCode={fileCode}
        required={openRedeemOverwriteModal ? false : required}
      />

      <Dragger {...props} disabled={disabled} id={fileCode} className="custom-drag">
        <UploadTitle />
        {errorFile && (
          <File
            error
            file={{
              notAcceptedSize,
              notAcceptedType,
              fileLimit,
              description: errorFile,
              name: errorFile,
            }}
            handleDeleteDocument={() => setErrorFile('')}
          />
        )}
        {!errorFile && safeFiles.length > 0 && (
          <div className="d-flex custom-drag__filelist-container">
            {safeFiles.map((file, index) => (
              <File
                key={index}
                file={file}
                percent={100}
                handleDeleteDocument={() => handleDelete(file)}
                uploadTempFiles={true}
              />
            ))}
          </div>
        )}
        {!errorFile && uploadedFiles?.length === 0 && (
          <ClickUpload fileAccepts={fileAccepts} fileLimit={fileLimit} />
        )}
      </Dragger>
    </div>
  );
};

Draggable.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    subLabel: PropTypes.string,
    linkText: PropTypes.string,
    fileCode: PropTypes.string.isRequired,
    fileLimit: PropTypes.number,
    multiple: PropTypes.bool,
    fileAccepts: PropTypes.string,
    required: PropTypes.bool,
  }).isRequired,
  disabled: PropTypes.bool,
  uploadedFiles: PropTypes.array.isRequired,
  setUploadedFiles: PropTypes.func.isRequired,
};

export default Draggable;